import { createContext } from "react";

export const SolutionKeyContext = createContext<string>("");
